import React from 'react';
import { FiHelpCircle } from 'react-icons/fi';
import CenterModalWindow from '../CenterModalWindow/CenterModalWindow';
import '../CenterModalWindow/CenterModalWindow.css';
import './ConfirmModal.css';

/**
 * Neutral confirmation dialog (CenterModalWindow) — brand styling, not destructive.
 */
export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  subtitle = '',
  description,
  confirmLabel = 'Yes',
  cancelLabel = 'Cancel',
  busy = false,
  icon: Icon = FiHelpCircle,
  width = 'min(420px, calc(100vw - 32px))',
}) {
  const handleConfirm = () => {
    if (busy || !onConfirm) return;
    onConfirm();
  };

  return (
    <CenterModalWindow
      isOpen={isOpen}
      onClose={onClose}
      width={width}
      height="auto"
      contentStyle={{ height: 'auto', maxHeight: 'min(90dvh, 520px)' }}
      contentClassName="confirm-modal"
    >
      <div className="confirm-modal__body" data-modal-scroll-port>
        <div className="confirm-modal__head">
          <div className="confirm-modal__icon" aria-hidden>
            <Icon />
          </div>
          <div className="confirm-modal__head-text">
            <h3 className="confirm-modal__title">{title}</h3>
            {subtitle ? <p className="confirm-modal__subtitle">{subtitle}</p> : null}
          </div>
        </div>
        {description ? <p className="confirm-modal__desc">{description}</p> : null}
        <div className="confirm-modal__actions">
          <button type="button" className="confirm-modal__cancel" onClick={onClose} disabled={busy}>
            {cancelLabel}
          </button>
          <button type="button" className="confirm-modal__confirm" onClick={handleConfirm} disabled={busy}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </CenterModalWindow>
  );
}
